import { useMutation } from 'react-query';
import { openApiHandler } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface VerifyEmailAnswerProps {
  answer: string;
  newPhoneNumberResponseCustomData: any;
  customerId: string;
}
export interface VerifyEmailAnswerReturn {
  newPhoneNumberResponseCustomData: {
    stateToken: string;
  };
}
export const useVerifyEmailCodeMutation = (
  onSuccess: (response: VerifyEmailAnswerReturn) => void,
  onError: (error: any) => void,
) =>
  useMutation(
    'verifyEmailAnswer',
    async ({ answer, newPhoneNumberResponseCustomData, customerId }: VerifyEmailAnswerProps) => {
      // eslint-disable-next-line no-useless-catch
      try {
        const data = await openApiHandler(
          `${BASE_URL}/api/v2/user/openauth/${customerId}/phone/change/verify`,
          'POST',
          {
            answer,
            newPhoneNumberResponseCustomData: { stateToken: newPhoneNumberResponseCustomData },
          },
        );
        return data as VerifyEmailAnswerReturn;
      } catch (e) {
        throw e;
      }
    },
    {
      onSuccess: (data) => onSuccess(data),
      onError: (error: IServerErrorResponse) => {
        onError(flattenServerErrorResponse(error));
      },
    },
  );
